import React from "react";

/**
 * Ston Link brand lockup: "STON LINK" wordmark with an optional
 * "Building Materials" subtitle underneath. Inherits `currentColor`.
 */
export default function StonLogo({
  size = 24,
  subtitle = "Building Materials",
  subtitleClassName = "",
  className = "",
  "data-testid": testId,
}) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid={testId}>
      <img
        src="/stonlink-mark.png"
        alt="Ston Link"
        className="object-contain shrink-0"
        style={{ height: Math.round(size * 1.55), width: "auto" }}
      />
      <div>
        <div className="ston-wordmark" style={{ fontSize: size, lineHeight: 1 }}>
          STON&nbsp;LINK
        </div>
        {subtitle ? (
          <div
            className={subtitleClassName}
            style={{
              fontSize: Math.max(9, Math.round(size * 0.26)),
              letterSpacing: "0.26em",
              textTransform: "uppercase",
              fontWeight: 600,
              marginTop: Math.round(size * 0.18),
              opacity: 0.7,
            }}
          >
            {subtitle}
          </div>
        ) : null}
      </div>
    </div>
  );
}
